import Link from 'next/link';

import styled from '@mui/system/styled';
import AppMenu from '@/components/Header/AppMenu';
import SearchInput from '../common/SearchInput';
import classNames from 'classnames';
import { Theme, useMediaQuery } from '@mui/material';

const Logo = styled('img')({
	display: 'block',
	height: 32,
});

export default function Header() {
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
	return (
		<>
			{isMobile ? (
				<div className='w-full'>
					<div
						className={classNames(
							'px-5 py-4 max-w-[1344px] mx-auto border-b border-borderSecondary',
							'flex items-center justify-between gap-2 flex-wrap',
						)}
					>
						<Link href={'/'} className='gap-1 h-full content-center'>
							<Logo src='/assets/Logo.svg' alt="Mayan Explorer" />
						</Link>
						<div className='justify-self-center'>
							<AppMenu />
						</div>
					</div>
					<div className='basis-full px-4 mt-6 mb-4'>
						<SearchInput />
					</div>
				</div>
			) : (
				<div className='w-full px-4 md:px-8 border-b border-borderSecondary mb-6'>
					<div
						className={classNames(
							'py-4 max-w-[1344px] mx-auto',
							'gap-2 md:gap-6 grid grid-cols-3',
						)}
					>
						<Link href={'/'} className='gap-1 sm:gap-2 h-full content-center'>
							<Logo src='/assets/Logo.svg' alt="Mayan Explorer" />
						</Link>
						<div className='justify-self-center'>
							<AppMenu />
						</div>
						<div className='basis-full md:basis-0'>
							<SearchInput />
						</div>
					</div>
				</div>
			)}
		</>
	);
}
